const LOW_STOCK_MIN_THRESHOLD = 250
const LOW_STOCK_MOQ_MULTIPLIER = 5

export function hasLowStock(inventory: number, minimumQuantity: number): boolean {
  if (inventory === 0) {
    return true
  }

  const lowStockThreshold = Math.max(LOW_STOCK_MIN_THRESHOLD, minimumQuantity * LOW_STOCK_MOQ_MULTIPLIER)

  return inventory <= lowStockThreshold
}
